/* Selector.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./Selector.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Fragment } from 'react';
import Tooltip from '@atlaskit/tooltip';
import { DefaultReactions } from '../../shared/constants';
import { EmojiButton } from './EmojiButton';
import { ShowMore } from '../ShowMore';
import { Box, Inline } from '@atlaskit/primitives/compiled';
var styles = {
  container: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
  separator: "_t6vde4h9 _5wramuej _1p3lnqa1 _ahbq1b66 _12l2u2gc _4t3i1tcg _1e0c1o8l"
};
var revealAnimation = null;
var revealStyle = null;

/**
 * Test id for wrapper Selector div
 */
export var RENDER_SELECTOR_TESTID = 'render-selector';
var Reveal = function Reveal(_ref) {
  var children = _ref.children,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId,
    className: ax(["_y44vlcmg _tzy4idpf"]),
    style: {
      "--_1m4wxxu": ix("".concat(revealAnimation, " 150ms ease-in-out forwards"))
    }
  }, children);
};

/**
 * Reactions picker panel part of the <ReactionPicker /> component
 */
export var Selector = function Selector(_ref2) {
  var emojiProvider = _ref2.emojiProvider,
    onMoreClick = _ref2.onMoreClick,
    onSelection = _ref2.onSelection,
    showMore = _ref2.showMore,
    _ref2$pickerQuickReac = _ref2.pickerQuickReactionEmojiIds,
    pickerQuickReactionEmojiIds = _ref2$pickerQuickReac === void 0 ? DefaultReactions : _ref2$pickerQuickReac;
  /**
   * Render the default emoji icon
   * @param emoji emoji item
   * @param index location of the emoji in the array
   */
  var renderEmoji = function renderEmoji(emoji, index) {
    var _emoji$id;
    return /*#__PURE__*/React.createElement(Reveal, {
      key: (_emoji$id = emoji.id) !== null && _emoji$id !== void 0 ? _emoji$id : emoji.shortName,
      testId: RENDER_SELECTOR_TESTID
    }, /*#__PURE__*/React.createElement(Tooltip, {
      content: emoji.shortName
    }, /*#__PURE__*/React.createElement(EmojiButton, {
      emojiId: emoji,
      emojiProvider: emojiProvider,
      onClick: onSelection
    })));
  };
  return /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    xcss: styles.container
  }, pickerQuickReactionEmojiIds ? pickerQuickReactionEmojiIds.map(renderEmoji) : null, showMore ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.separator
  }), /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement(ShowMore, {
    key: "more",
    onClick: onMoreClick
  }))) : null);
};